/* eslint-disable */
import './PriceWarrantyBlock.css'
import PriceWarrantyBlock from './PriceWarrantyBlock';

export default PriceWarrantyBlock;
